import SourceProductConfigurableAttributes from 'SourceComponent/ProductConfigurableAttributes/ProductConfigurableAttributes.component';

class ProductConfigurableAttributes extends SourceProductConfigurableAttributes {
    state = {
        swatchListOpen: []
    }

    handleShowMore = (attribute_id) => {
        const { swatchListOpen } = this.state;

        if (swatchListOpen.indexOf(attribute_id) !== -1) {
            this.setState({
                swatchListOpen: swatchListOpen.filter(attr => attr !== attribute_id)
            })
        } else {
            this.setState({
                swatchListOpen: [...swatchListOpen, attribute_id]
            })
        }
    }

    renderShowMore(showSeeMore, attribute_id) {
        const { swatchListOpen } = this.state;

        if (!showSeeMore) {
            return null;
        }

        return (
            <div block="ProductConfigurableAttributes" elem="SwatchListLimit">
                <span onClick={() => this.handleShowMore(attribute_id)}>{ swatchListOpen.indexOf(attribute_id) === -1 ? __("See more") : __("See less") }</span>
            </div>
        )
    }


    renderSwatch(option) {
        const { swatchListOpen } = this.state;
        const { attribute_id, attribute_values } = option;

        const showSeeMore = attribute_values.length > 22;

        return (
            <>
                <div
                  block="ProductConfigurableAttributes"
                  elem="SwatchList"
                  mods={{ showSeeMore: swatchListOpen.indexOf(attribute_id) !== -1 ? false : showSeeMore }}
                >
                    { attribute_values.map((attribute_value) => (
                        this.renderConfigurableAttributeValue({ ...option, attribute_value })
                    )) }
                </div>
                { this.renderShowMore(showSeeMore, attribute_id) }
            </>
        );
    }

    renderConfigurableAttributes() {
        const {
            configurable_options,
            getSubHeading
        } = this.props;

        return Object.values(configurable_options).map((option) => {
            const {
                attribute_label,
                attribute_code,
                attribute_options
            } = option;

            const [{ swatch_data }] = attribute_options ? Object.values(attribute_options) : [{}];
            const isSwatch = !!swatch_data;

            return (
                <div block="ProductConfigurableAttribute" key={ attribute_code }>
                    <div block="ProductConfigurableAttribute" elem="Title">
                        <strong>{ attribute_label } </strong>
                        <strong className="SubHeading">{ getSubHeading(option) }</strong>
                    </div>
                    { isSwatch ? this.renderSwatch(option) : this.renderDropdown(option) }
                </div>
            );
        });
    }
}

export default ProductConfigurableAttributes;
